/** Service Desk console: Settings -> Connectors (SD-SC-17), part E: sync jobs and starter templates. */
export const serviceConnectorsE = {
  sync: {
    intro: "Scheduled pulls of a published read operation into Sagot's own tables (products, assets, contacts, organisations), matched by the system's own id.",
    add: "Add sync job",
    edit: "Edit {{name}}",
    emptyTitle: "No sync jobs",
    emptyBody: "{{name}} is queried live and nothing is stored in Sagot. Add a scheduled pull if you need the data in Sagot's tables.",
    lockTitle: "Sync jobs are included from the Pro plan",
    lockBody: "Keep your catalogue, assets, contacts or organisations up to date from your own system on a schedule. Upgrade to switch sync jobs on.",
    dialogHint: "Pick a published read operation whose mapping fills the kind of record you choose.",
    tableLabel: "Sync jobs",
    name: "Job name",
    nameRequired: "Give the job a name.",
    operation: "Operation",
    operationHint: "Only published read operations can be synced.",
    noEligible: "Publish a read operation first.",
    operationRequired: "Choose an operation.",
    choose: "Choose…",
    target: "Fills",
    targetHint: "Kinds of record available in your workspace.",
    targets: { products: "Products", assets: "Assets", contacts: "Contacts", organisations: "Organisations" },
    schedule: "Schedule",
    schedules: { manual: "Manual only", hourly: "Hourly", nightly: "Nightly", custom: "Custom" },
    everyMinutes_one: "Every {{count}} minute",
    everyMinutes_other: "Every {{count}} minutes",
    interval: "Minutes between runs",
    intervalInvalid: "At least {{min}} minutes.",
    deletion: "Records the system no longer lists",
    deletionHint: "Keep them, or archive them in Sagot.",
    deletions: { keep: "Keep", archive: "Archive" },
    incremental: "Only pull what changed",
    incrementalHint: "Passes the time of the last clean pull to the operation.",
    param: "Parameter that takes the time",
    paramHint: "A parameter of the operation, like updated_since.",
    paramInvalid: "Use lowercase letters, numbers and underscores.",
    format: "Time format",
    formats: { iso: "ISO 8601", date: "Date only", epoch: "Unix seconds" },
    enabled: "Enabled",
    enabledAria: "Enable {{name}}",
    lastRun: "Last run",
    nextRun: "Next run",
    neverRun: "Never run",
    status: { queued: "Queued", running: "Running", succeeded: "Succeeded", partial: "Partly done", failed: "Failed" },
    runNow: "Run now",
    runNowAria: "Run {{name}} now",
    queued: "{{name}} queued",
    runs: "Runs",
    runsAria: "Runs of {{name}}",
    started: "Started",
    noRuns: "No runs yet.",
    counts: { fetched: "Fetched", created: "Created", updated: "Updated", unchanged: "Unchanged", failed: "Failed" },
    saved: "Sync job saved",
    deleteAria: "Delete {{name}}",
    deleteTitle: "Delete {{name}}?",
    deleteBody: "The schedule and its run history are removed. Records already synced stay in Sagot.",
    deleteConfirm: "Delete job",
  },
  templates: {
    crm: {
      name: "CRM lookup",
      hint: "Find a contact by e-mail or id in your CRM.",
      ops: {
        find_contact_by_email: { name: "Find contact by e-mail", ai: "Finds a contact in the CRM by e-mail address and returns their id and name." },
        get_contact: { name: "Get contact", ai: "Returns one contact from the CRM by id." },
      },
    },
    orders: {
      name: "Order system",
      hint: "Order status, tracking and placing an order.",
      ops: {
        get_order_status: { name: "Look up order status", ai: "Looks up the status and tracking of one order by its number. Safe to call." },
        list_orders: { name: "List a customer's orders", ai: "Lists the orders of one customer." },
        create_order: { name: "Create order", ai: "Places an order. A write: the assistant may only propose it; it runs after the client confirms." },
      },
    },
    records: {
      name: "Student or HR record lookup",
      hint: "Look up a student, employee or member record by number or e-mail.",
      ops: {
        lookup_record: { name: "Look up a record", ai: "Looks up one record by its number and returns its status." },
        find_record_by_email: { name: "Find a record by e-mail", ai: "Finds the record number that belongs to an e-mail address." },
      },
    },
    booking: {
      name: "Booking",
      hint: "Free slots, new bookings and cancellations.",
      ops: {
        list_slots: { name: "List free slots", ai: "Lists the free time slots for a date and optionally a service." },
        create_booking: { name: "Create booking", ai: "Books a slot. A write: needs the client's confirmation." },
        cancel_booking: { name: "Cancel booking", ai: "Cancels a booking. Destructive: staff or confirmed clients only." },
      },
    },
    billing: {
      name: "Billing status",
      hint: "Invoice status and a customer's invoices.",
      ops: {
        get_invoice_status: { name: "Get invoice status", ai: "Returns the status and amount due of one invoice." },
        list_invoices: { name: "List a customer's invoices", ai: "Lists the invoices of one customer." },
      },
    },
    tickets: {
      name: "Ticket tool",
      hint: "Read or open tickets in another helpdesk.",
      ops: {
        get_ticket: { name: "Get ticket", ai: "Returns the status of one ticket in the other tool." },
        create_ticket: { name: "Create ticket", ai: "Opens a ticket in the other tool. A write: needs a confirmation." },
      },
    },
    assets: {
      name: "Equipment register",
      hint: "Find a unit of equipment by its serial number.",
      ops: { lookup_serial: { name: "Find equipment by serial number", ai: "Finds one unit of equipment by its serial number and returns its model, owner and the end date of its warranty. Safe to call." } },
    },
    custom: {
      name: "Custom API",
      hint: "Your own internal API, starting from a health check.",
      ops: { ping: { name: "Health check", ai: "Checks that the system answers. No data is read." } },
    },
  },
};
